const sounds = [
    {
        mp3: 'chaching.mp3',
        wav: 'chaching.wav'
    },
    {
        mp3: 'cash-register.mp3',
        wav: 'cash-register.wav'
    },
    {
        mp3: 'money-chink.mp3',
        wav: 'money-chink.wav'
    },
    {
        mp3: 'single-coin.mp3',
        wav: 'single-coin.wav'
    },
    {
        mp3: 'count-money-cut.mp3',
        wav: 'count-money-cut.wav'
    }

]

const play_sound = (i) =>
{
    const money_sound = new Howl(
        {
            src: [ `./assets/sounds/${sounds[i].mp3}`, `./assets/sounds/${sounds[i].wav}`  ],
            volume: 0.3,
        } );

    money_sound.play();
}

const stop_sound = () =>
{
    cha_ching_sound.stop();
}